import type { MarketplaceOrder, ShoppingCoupon } from '@redd/contracts';
import { formatPrice } from './market-data';

export function couponEligibleForPurchase(coupon: ShoppingCoupon, priceFen: number, now = Date.now()) {
  return coupon.status === 'available' && coupon.environment !== 'Sandbox'
    && Number.isFinite(Date.parse(coupon.expiresAt)) && Date.parse(coupon.expiresAt) > now
    && Number.isSafeInteger(priceFen) && priceFen > 0
    && Number.isSafeInteger(coupon.thresholdFen) && coupon.thresholdFen >= 0 && coupon.thresholdFen <= priceFen
    && Number.isSafeInteger(coupon.discountFen) && coupon.discountFen > 0
    && (coupon.source === 'membership' || coupon.discountFen <= priceFen);
}

export function purchaseCouponDiscount(coupon: ShoppingCoupon | undefined, priceFen: number, now = Date.now()) {
  return coupon && couponEligibleForPurchase(coupon, priceFen, now) ? Math.min(priceFen, coupon.discountFen) : 0;
}

export function purchaseCouponLabel(coupon: ShoppingCoupon) {
  return coupon.source === 'membership'
    ? `会员购货券 · 最高抵扣 ${formatPrice(coupon.discountFen)}`
    : `满 ${formatPrice(coupon.thresholdFen)} 减 ${formatPrice(coupon.discountFen)}`;
}

export function buyerPaymentFen(order: Pick<MarketplaceOrder, 'amountFen' | 'discountFen'>) {
  return Math.max(0, order.amountFen - (order.discountFen ?? 0));
}
